module.exports = __webpack_public_path__ + "static/media/1_A1_23.be7ebf4f.png";